import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { isAndroidPhone, isIPhoneOrIPad } from 'src/app/shared/utils/userAgent';

export function useIsSmsCapable(): boolean {
	const utilityContext = useUtilityContext();

	return isIPhoneOrIPad(utilityContext) || isAndroidPhone(utilityContext);
}
